// Superior (escalonamento) por membro + utilidades da visão de equipe.
import { supabase } from './supabase';

/** Mapa user_id → manager_id (superior). Tolerante caso a coluna ainda não exista. */
export async function loadManagers(orgId: string): Promise<Record<string, string | null>> {
  try {
    const { data, error } = await supabase
      .from('memberships')
      .select('user_id, manager_id')
      .eq('org_id', orgId);
    if (error) return {};
    const out: Record<string, string | null> = {};
    for (const r of (data ?? []) as { user_id: string; manager_id: string | null }[]) {
      out[r.user_id] = r.manager_id ?? null;
    }
    return out;
  } catch {
    return {};
  }
}

/** Define (ou limpa) o superior de um membro. RLS: admin. */
export async function setManager(
  orgId: string,
  userId: string,
  managerId: string | null,
): Promise<{ error?: string }> {
  const { error } = await supabase
    .from('memberships')
    .update({ manager_id: managerId })
    .eq('org_id', orgId)
    .eq('user_id', userId);
  return { error: error?.message };
}
